export default __webpack_public_path__ + "static/media/img-intro@2x.6e3cdb74.png";